'use strict';

angular.module('adminModule', [
]);
